var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9993 0C28.3357 0.000121389 32.8686 9.01845 33.8743 11.4189C34.0324 11.7963 34.0405 12.2056 33.8949 12.5879C32.9766 14.9986 28.7606 23.9999 16.9993 24C5.23825 23.9998 1.02208 14.9987 0.103835 12.5879C-0.0417205 12.2056 -0.0336674 11.7962 0.124343 11.4189C1.13009 9.01838 5.66309 0.000168714 16.9993 0ZM16.9993 3C11.9995 3.00017 7.94563 7.02954 7.94563 12C7.94563 16.9705 11.9995 20.9998 16.9993 21C21.9992 20.9999 26.0521 16.9705 26.0521 12C26.0521 7.02951 21.9992 3.00012 16.9993 3ZM21.8275 8.79102C22.2192 8.40179 22.8522 8.40329 23.2415 8.79492C23.6306 9.18647 23.6288 9.81963 23.2376 10.209L17.2015 16.209L16.5423 16.8652L15.8402 16.2549L11.8167 12.7549C11.4001 12.3925 11.3558 11.7605 11.7181 11.3438C12.0805 10.9272 12.7126 10.8829 13.1292 11.2451L16.4505 14.1348L21.8275 8.79102Z",
    fill: "#18A7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInEye);
export default __webpack_public_path__ + "static/media/check-in-eye.37bdcaba231cbce30ed939966b00ac0b.svg";
export { ForwardRef as ReactComponent };